import { map, omit, concat } from 'lodash'
import { http, queryString } from 'utils'

// User mutation imports.
import { SET_LIST} from 'vx/mutations'



// Contact state.
const state = {
  opportunities: []
}

// User state getters.
const getters = {
  /**
   * User state as a decorated object.
   */
  opportunities: state => state.opportunities,

  getById: (state) => (id) => {
    return state.opportunities.find(opportunity => opportunity.id === id)
  }
}

// User actions.
const actions = {

  /**
   * Get a list of opportunities.
   */
  getOpportunities ({ commit }, payload) {
    return http.get(`/opportunities/list`, {params: payload}).then(response => {
      commit(SET_LIST, response.data)

      return response
    })
  },
}

// User state mutations.
const mutations = {
  
  /**
  * Set the clients state.
  */
  [SET_LIST] (state, opportunities) {
    state.opportunities = opportunities
  }
}

// Export our state, getters, actions, mutations, and modules.
export default {
  namespaced: true, state, getters, actions, mutations
}
